module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L_BlackMatted_MockedUp.72a3f1af.jpg";